import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initWebVitals } from "./lib/report-web-vitals";
import { scrubTokenParams } from "@shared/path-guards";

// Initialize Sentry for frontend error tracking (S5-BE-04)
if (import.meta.env.VITE_SENTRY_DSN) {
  // 868mkqxu0: the email preferences link carries its signed token as
  // `?token=`, and it does not expire. It is redacted from errors,
  // transactions, breadcrumbs and the replay's custom events. The replay's DOM
  // recording keeps the page URL and cannot be scrubbed, so a page opened with
  // a token in the URL is not recorded at all.
  const tokenInUrl = new URLSearchParams(window.location.search).has("token");
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      ...(tokenInUrl ? [] : [Sentry.replayIntegration({ beforeAddRecordingEvent: (event) => scrubTokenParams(event) })]),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,   // no grabar sesiones normales
    replaysOnErrorSampleRate: 1.0, // sí grabar replay cuando hay un error
    sendDefaultPii: true,
    beforeSend: (event) => scrubTokenParams(event),
    beforeSendTransaction: (event) => scrubTokenParams(event),
    beforeBreadcrumb: (breadcrumb) => scrubTokenParams(breadcrumb),
  });
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<SentryFallback />}>
    <App />
  </Sentry.ErrorBoundary>
);

// Core Web Vitals — S5-FE-05 (lazy-loaded, non-blocking)
initWebVitals();

function SentryFallback() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>Something went wrong</h1>
      <p>The error has been reported. Please refresh the page.</p>
      <button onClick={() => window.location.reload()}>Refresh</button>
    </div>
  );
}
